<template>
  <b-row class="px-4">
    <b-col sm="12" class="result-summary rounded">
     <div class="d-flex justify-content-between">
        <div v-if="params.departureName">
          <span class="tag-details"><translate>Departure</translate></span> <span class="name-details">{{ params.departureName }}</span>
        </div>
        <div>
          <span class="tag-details"><translate>Transport</translate>: </span>
          <span v-if="params.transport === 'flight'" class="name-details"> <translate>Flight</translate></span>
          <span v-if="params.transport === 'bus'" class="name-details"> <translate>Bus</translate></span>
          <span v-if="params.transport === 'own'" class="name-details"> <translate>Own</translate></span>
        </div>
        <div v-if="routeTour.name === 'Private/Package/Search'">
          <span class="tag-details"><translate>Destination</translate>: </span> <span class="name-details">{{params.resortName}}</span>
        </div>
        <div>
          <span class="tag-details"><translate>Date</translate>: </span> <span class="name-details">{{departureDate}}</span>
        </div>
        <div>
          <span class="tag-details"><translate>Nights</translate>: </span> <span class="name-details">{{params.duration}}</span>
        </div>
        <template v-if="category">
          <div>
            <span class="tag-details"><translate>Room type</translate>: </span> <span class="name-details">{{category.name}}</span>
          </div>
          <div>
            <span class="tag-details"><translate>Meal type</translate>: </span> <span class="name-details">{{meal.label}}</span>
          </div>
        </template>
        <div v-for="(room, index) in params.rooms" :key="index">
          <span class="tag-details"><translate>Room</translate>: {{index + 1 }} - </span>
          <span>{{room.adults}} </span><span class="name-details" v-translate> adults</span>
          <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} <translate>children</translate> </span>
        </div>
     </div>
     <hr class="my-1"/>
     <div>
       <small class="float-right">
          <b v-translate>generated by</b> -
          <span class="name-details"> {{userData.fname}} {{userData.lname}}</span> /
          <span class="name-details"> {{dateNow}}</span>
       </small>
     </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import auth from 'b2b-common/mixins/auth'

export default {
  props: ['params', 'category', 'meal'],
  mixins: [auth],
  computed: {
    departureDate: function () {
      const d = moment(this.params.date, 'X')
      return d.format('DD-MM-YYYY')
    },
    dateNow () {
      const date = moment(this.dateToday)
      return date.format('DD-MM-YYYY - [ora ]LT')
    },
    routeTour () {
      return this.$route
    }
  }
}
</script>
